const defaultLocale = 'hr'
const localeCookieName = 'locale'

export default {
  defaultLocale,
  localeCookieName,
}
